import React from "react";
import { useApp } from "../../context/AppContext";
import LegalLayout, { LegalSection } from "./LegalLayout";
import { L } from "../../components/marketing/MarketingChrome";

export default function LegalNotice() {
  const { lang } = useApp();
  return (
    <LegalLayout testid="legal-notice-page" path="/legal"
      seoDescription={L(lang, "Mentions legales et informations sur l'editeur de Cockpit OS.", "Legal notice and publisher information for Cockpit OS.")}
      title={L(lang, "Mentions légales", "Legal Notice")}
      updated={L(lang, "[date]", "[date]")}>

      <LegalSection heading={L(lang, "Éditeur du site", "Site publisher")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{L(lang, "Raison sociale : [Nom légal de la société]", "Legal name: [Company legal name]")}</li>
          <li>{L(lang, "Forme juridique : [SARL / SAS / ...]", "Legal form: [Ltd / SAS / ...]")}</li>
          <li>{L(lang, "Capital social : [montant]", "Share capital: [amount]")}</li>
          <li>{L(lang, "Siège social : [adresse complète]", "Registered office: [full address]")}</li>
          <li>{L(lang, "Immatriculation : [SIRET / RCS / numéro]", "Registration: [company number]")}</li>
          <li>{L(lang, "Numéro de TVA : [TVA intracommunautaire]", "VAT number: [VAT number]")}</li>
          <li>{L(lang, "Directeur de la publication : [nom]", "Publication director: [name]")}</li>
          <li>{L(lang, "Contact : [email de contact]", "Contact: [contact email]")}</li>
        </ul>
      </LegalSection>

      <LegalSection heading={L(lang, "Hébergement", "Hosting")}>
        <p>{L(lang,
          "Le site et les données sont hébergés en Europe (UE-Ouest, Amsterdam) par [nom de l'hébergeur], [adresse de l'hébergeur].",
          "The site and data are hosted in Europe (EU-West, Amsterdam) by [hosting provider name], [hosting provider address].")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "Propriété intellectuelle", "Intellectual property")}>
        <p>{L(lang,
          "La marque, le logo et le contenu du site sont la propriété de [Nom légal de la société]. Le contenu que vous créez dans l'application reste votre propriété.",
          "The brand, logo and site content are the property of [Company legal name]. The content you create in the app remains your property.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "Cookies", "Cookies")}>
        <p>{L(lang,
          "Ce site n'utilise qu'un cookie de session strictement nécessaire au fonctionnement du service. Aucun cookie de suivi ou de mesure d'audience n'est déposé.",
          "This site only uses a session cookie strictly necessary for the service to work. No tracking or analytics cookies are set.")}</p>
      </LegalSection>
    </LegalLayout>
  );
}
